export default __webpack_public_path__ + "static/media/welcome-male@3x.7b9785f1.png";